































  import { Validable } from '@/commun/components/champ-formulaire/mixins/validable';
  import { Validations } from '@/commun/validations/validations';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'RadioGroupOuiNon',
    mixins: [Validable],
    props: {
      libelle: {
        type: String,
        required: true,
      },
      value: {
        type: Boolean,
        default: undefined,
      },
      validation: {
        type: String,
        default: Validations.Requis,
      },
      reinitialisable: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      onClickRetirerSelection(): void {
        this.$emit('input', null);
      },
    },
  });
